import apiClient from "../../../services/apiClient";

// 결산은 로그인한 사람만 본다.
//
// 새 탭으로 주소를 열면 JWT 가 실리지 않는다. 그래서 화면이 XHR 로 HTML 을 받아
// **앱 안에서 그대로 띄운다**(`MonthlySummaryViewer`). 새 탭 + `blob:` 도 해 봤지만
// 아이폰 사파리가 blob 주소로의 새 탭 이동을 막아서 아무것도 안 뜬다. 원장 절반이
// 폰으로 들어오므로 앱 안에서 여는 쪽이 맞다.
export const MONTHLY_SUMMARY_EVENT = "monthly-summary-open";

export const openMonthlySummary = async ({ month, userId, title } = {}) => {
  window.dispatchEvent(
    new CustomEvent(MONTHLY_SUMMARY_EVENT, {
      detail: { loading: true, title: title || "" },
    })
  );

  try {
    const response = await apiClient.get("/api/v1/echo/monthly-summary/view", {
      params: {
        ...(month ? { month } : {}),
        ...(userId ? { user_id: userId } : {}),
      },
      withAuth: true,
      responseType: "text",
    });
    window.dispatchEvent(
      new CustomEvent(MONTHLY_SUMMARY_EVENT, {
        detail: { html: response.data, title: title || "" },
      })
    );
    return true;
  } catch (error) {
    window.dispatchEvent(
      new CustomEvent(MONTHLY_SUMMARY_EVENT, { detail: { error: true } })
    );
    return false;
  }
};
